import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {FinishedResponseInteractionService, WalkerService} from 'shared/services';
import type {StateProvider, Transition} from '@uirouter/angularjs';
import type {KpUserAccountPageService} from './kp-user-account-page/kp-user-account-page.service';
import type UserDataService from './user.data-service';
import {exists} from 'shared/utils/custom-utils';

/*@ngInject*/
export default function userRoutes($stateProvider: StateProvider) {
    let userList: {default: any;};
    let userAccount: {default: any;};

    $stateProvider
        .state('users', {
            url: '/users?userType',
            params: {userType: {dynamic: true}},
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                /*@ngInject*/
                component: () => userList.default,
                props: async (userDataService: UserDataService, finishedResponseInteractionService: FinishedResponseInteractionService) => {
                    try {
                        const usersView = await userDataService.getUsersView();
                        return {view: usersView};
                    } catch (exceptionResponse) {
                        await finishedResponseInteractionService.showFailedInModalWindow(exceptionResponse);
                        throw exceptionResponse;
                    }
                }
            },
            lazyLoad: async () => {
                userList = await import(/* webpackChunkName: "userList" */ './kp-user-list-page/KpUserListPage.svelte');
                return null;
            }
        });

    $stateProvider
        .state({
            name: 'user',
            url: '/users/:userId?activeTab',
            params: {activeTab: {dynamic: true}},
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                /*@ngInject*/
                component: () => userAccount.default,
                props: async (
                    $transition$: Transition,
                    kpUserAccountService: KpUserAccountPageService,
                    walker: WalkerService
                ) => {
                    const userId = $transition$.params().userId;
                    const pageData = await kpUserAccountService.loadUserAccountPageData(userId);

                    if (pageData.detailView.isSutorSutinLayout && exists(pageData.userRecord)) {
                        await walker.newSpaPage(`/records/${pageData.userRecord.id}`);
                        return {pageData, redirecting: true};
                    }

                    return {pageData};
                }
            },
            lazyLoad: async () => {
                userAccount = await import(/* webpackChunkName: "userAccount" */ './kp-user-account-page/KpUserAccountPage.svelte');
                return null;
            }
        });
}
